// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__vXzTg","comment":"styles_comment__2wUxZ"};